import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js';
import CreateComplianceModalUI from './CreateComplianceModalUI.js';
import CacheManager from '../../../cache/CacheManager.js';
import CacheKeys from '../../../cache/CacheKeys.js';

class CreateComplianceModalSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      complianceCode: '',
      complianceCodeError: null,
      complianceCodeList: [],
      clause: '',
      clauseError: null,
      clauseCodeList: [],
      remarks: '',
      remarksError: null,
    };
  }

  render() {
    let penaltyStatusList = [
      { key: 'waived', value: 'Waived' },
      { key: 'not_waived', value: 'Not Waived' }
    ];
    return (
      <CreateComplianceModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        complianceCode={this.state.complianceCode}
        onComplianceCodeChange={this.onComplianceCodeChange}
        complianceCodeError={this.state.complianceCodeError}
        setComplianceCodeError={(error) => { this.setState({ complianceCodeError: error }) }}
        complianceCodeList={this.state.complianceCodeList}
        //
        clause={this.state.clause}
        onClauseChange={(event) => { this.setState({ clause: event.target.value }) }}
        clauseError={this.state.clauseError}
        setClauseError={(error) => { this.setState({ clauseError: error }) }}
        clauseCodeList={this.state.clauseCodeList}
        //
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        //
        penaltyStatus={this.state.penaltyStatus}
        onPenaltyStatusChange={(event) => { this.setState({ penaltyStatus: event.target.value }) }}
        penaltyStatusError={this.state.penaltyStatusError}
        setPenaltyStatusError={(error) => { this.setState({ penaltyStatusError: error }) }}
        penaltyStatusList={penaltyStatusList}
      />
    );
  }

  onComplianceCodeChange = (event) => {
    let complianceCode = event.target.value
    let selectedCompliance = this.state.complianceList.filter(c => c.complianceCode === complianceCode)[0]
    let clauseCodeList = selectedCompliance.clauseList.map(clause =>
      ({ key: clause.clauseCode, value: clause.clauseLabel })
    )
    this.setState({ complianceCode: complianceCode, clauseCodeList: clauseCodeList })
  }

  componentDidMount() {
    let context = this.props.context;
    this.getCompList(context)
    Modal.setAppElement('body');
  }

  getCompList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/legalLanguage`,
      cacheKey: CacheKeys.CompList(),
      callback: this.getCompListCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getCompListCallback = (response) => {
    let complianceCodeList = response.complianceList.map(compliance =>
      ({ key: compliance.complianceCode, value: compliance.complianceName })
    )
    this.setState({ complianceList: response.complianceList, complianceCodeList: complianceCodeList })
  }

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    });

    RestApiUtils.post(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances`,
      this.submitCallback, {
      complianceCode: this.state.complianceCode,
      clause: this.state.clause,
      remarks: this.state.remarks,
      penaltyStatus: this.state.penaltyStatus,
    }
    );
  };

  submitCallback = (response) => {
    let errorList = [];
    if (response.errorList) {
      response.errorList.forEach((error) => {
        errorList.push(error.message);
      });
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    });

    if (!response.errorList || response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        });
        this.props.onCancelClick();
        this.props.onRefreshClick('noBusy');
      }, 10);
    }
  };
}

export default CreateComplianceModalSF;
